var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [
            _vm._v(
              "\n        Ruta de Cobros\n        " +
                _vm._s(
                  _vm.form.numero_documento === ""
                    ? ""
                    : "- " + _vm.form.numero_documento
                ) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("label", [
            _vm.form.id
              ? _c("div", { class: _vm.getEstadoColor(_vm.form.estado) }, [
                  _vm._v("\n          ESTADO:\n          "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.getEstadoParse(_vm.form.estado)))
                  ])
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.limpiar }
              },
              [
                _c("i", { staticClass: "fa fa-trash" }),
                _c("span", [_vm._v("Limpiar")])
              ]
            ),
            _vm._v(" "),
            (_vm.rutaCobros || _vm.form.id) &&
            _vm.form.estado == "A" &&
            _vm.puedeCerrar &&
            !_vm.esFechaFutura
              ? _c(
                  "button",
                  {
                    staticClass: "btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.aperturaCierrerRuta("C")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-lock" }),
                    _c("span", [_vm._v("Cerrar")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.rutaCobros || _vm.form.id) &&
            _vm.form.estado == "C" &&
            _vm.puedeAbrir
              ? _c(
                  "button",
                  {
                    staticClass: "btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.aperturaCierrerRuta("A")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-unlock" }),
                    _c("span", [_vm._v("Abrir")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.rutaCobros || _vm.form.id) && _vm.form.estado == "A"
              ? _c(
                  "button",
                  {
                    staticClass: "btn-warning",
                    attrs: { type: "button" },
                    on: { click: _vm.actualizarPrestamos }
                  },
                  [
                    _c("i", { staticClass: "fa fa-refresh" }),
                    _c("span", [_vm._v("Actualizar")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.rutaCobros == null && !_vm.form.id,
                    expression: "rutaCobros == null && !form.id"
                  }
                ],
                staticClass: "btn-primary",
                attrs: { type: "generar" },
                on: { click: _vm.generar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Generar")])
              ]
            ),
            _vm._v(" "),
            _vm.form.estado == "A" &&
            ((!_vm.form.id && _vm.puedeCrear) ||
              (_vm.form.id && _vm.puedeEditar))
              ? _c(
                  "button",
                  {
                    staticClass: "btn-success",
                    attrs: { type: "button" },
                    on: { click: _vm.confirmarGuardar }
                  },
                  [
                    _c("i", { staticClass: "fa fa-save" }),
                    _c("span", [_vm._v("Guardar")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.rutaCobros || _vm.form.id
              ? _c(
                  "button",
                  {
                    staticClass: "btn-secondary",
                    on: { click: _vm.abrirModalAuditoria }
                  },
                  [
                    _c("i", { staticClass: "fa fa-list" }),
                    _c("span", [_vm._v("Auditoría")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.rutaCobros || _vm.form.id,
                    expression: "rutaCobros || form.id"
                  }
                ],
                staticClass: "btn-danger",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.imprimirCierre("P")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-file-pdf-o" }),
                _c("span", [_vm._v("Imprimir cierre")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.rutaCobros || _vm.form.id,
                    expression: "rutaCobros || form.id"
                  }
                ],
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.imprimirCierre("E")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _c("span", [_vm._v("Imprimir cierre")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.rutaCobros || _vm.form.id,
                    expression: "rutaCobros || form.id"
                  }
                ],
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.imprimirRecibos }
              },
              [
                _c("i", { staticClass: "fa fa-file" }),
                _c("span", [_vm._v("Imprimir recibos")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "fecha",
                        locale: "es",
                        "no-label": "",
                        "only-date": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione una fecha...",
                        disabled: _vm.form.prestamos.length > 0
                      },
                      model: {
                        value: _vm.form.fecha,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fecha", $$v)
                        },
                        expression: "form.fecha"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Fecha")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                {
                  staticClass: "form-field select2",
                  class: {
                    "select2--disabled": _vm.form.prestamos.length > 0
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          id: "ruta_id",
                          options: _vm.rutas,
                          label: "descripcion"
                        },
                        on: { input: _vm.inputRuta, search: _vm.onSearchRutas },
                        model: {
                          value: _vm.selectedRuta,
                          callback: function($$v) {
                            _vm.selectedRuta = $$v
                          },
                          expression: "selectedRuta"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "ruta" } }, [_vm._v("Ruta")]),
                      _vm._v(" "),
                      _vm.errores.ruta_id
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.ruta_id[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                {
                  staticClass: "form-field select2",
                  class: {
                    "select2--disabled": _vm.rutaCobros != null || _vm.form.id
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          placeholder: "Seleccione...",
                          id: "recaudador_id",
                          options: _vm.recaudadores,
                          label: "nombre"
                        },
                        on: {
                          search: _vm.onSearchRecaudadores,
                          input: _vm.inputRecaudador
                        },
                        model: {
                          value: _vm.selectedRecaudador,
                          callback: function($$v) {
                            _vm.selectedRecaudador = $$v
                          },
                          expression: "selectedRecaudador"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "recaudador_id" } }, [
                        _vm._v("Recaudador")
                      ]),
                      _vm._v(" "),
                      _vm.errores.recaudador_id
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.recaudador_id[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__title" }, [
          _c(
            "h5",
            [
              _vm._v("Clientes "),
              _vm.form.prestamosFilter.length > 0
                ? [_vm._v("(" + _vm._s(_vm.form.prestamosFilter.length) + ")")]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card__controls" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _vm.form.id
                  ? _c(
                      "input-field",
                      {
                        attrs: {
                          id: "filtro_cliente",
                          placeholder: "Realice una búsqueda...",
                          stretch: ""
                        },
                        on: { keyup: _vm.search },
                        model: {
                          value: _vm.form.search,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "search", $$v)
                          },
                          expression: "form.search"
                        }
                      },
                      [_c("span", [_vm._v("Buscar:")])]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "d-flex jc-between mb-2" }, [
            _c("div", [
              _vm.form.id &&
              _vm.form.estado == "A" &&
              _vm.puedeCrearPrestamos &&
              !_vm.esFechaFutura
                ? _c(
                    "button",
                    {
                      staticClass: "btn-primary",
                      attrs: { title: "Nuevo préstamo", type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.abrirModalPrestamo(null, "NR")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _c("span", [_vm._v("Préstamo")])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.estado == "A" &&
              _vm.form.id &&
              _vm.form.saldada === "N" &&
              _vm.puedeSaldar &&
              !_vm.esFechaFutura
                ? _c(
                    "button",
                    {
                      staticClass: "btn-success",
                      attrs: { type: "button" },
                      on: { click: _vm.saldar }
                    },
                    [
                      _c("i", { staticClass: "fa fa-money" }),
                      _c("span", [_vm._v("Saldar")])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.estado == "A" &&
              _vm.form.id &&
              _vm.form.saldada === "S" &&
              _vm.puedePagarDominicalRuta &&
              !_vm.esFechaFutura
                ? _c(
                    "button",
                    {
                      staticClass: "btn-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.abrirModalPagarDominicalRuta }
                    },
                    [
                      _c("i", { staticClass: "fa fa-handshake-o" }),
                      _c("span", [_vm._v("Dominical")])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.estado == "A" &&
              _vm.form.id &&
              _vm.puedeAbonarPrestamosAgendados &&
              !_vm.esFechaFutura
                ? _c(
                    "button",
                    {
                      staticClass: "btn-warning",
                      attrs: { type: "button" },
                      on: { click: _vm.mostrarCreditosAgendados }
                    },
                    [
                      _c("i", { staticClass: "fa fa-address-book" }),
                      _c("span", [_vm._v("Créditos agendados")])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.estado == "A" &&
              _vm.form.id &&
              _vm.puedeAsignarFechaMasiva &&
              !_vm.esFechaFutura &&
              _vm.form.saldada === "S"
                ? _c(
                    "button",
                    {
                      staticClass: "btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.mostrarModalFechaMasiva }
                    },
                    [
                      _c("i", { staticClass: "fa fa-calendar-o" }),
                      _c("span", [_vm._v("Asignar fecha masiva")])
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.prestamosFilter.length > 0,
                    expression: "form.prestamosFilter.length > 0"
                  }
                ],
                staticClass: "indicadores"
              },
              [
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _vm._m(4),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _vm._m(6)
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", [
              _c("thead", [
                _c("tr", [
                  _c("th"),
                  _vm._v(" "),
                  _c("th"),
                  _vm._v(" "),
                  _c("th", [_vm._v("Cliente")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Cédula")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Crédito")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("CC")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("CF")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("PD")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("AT")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("ST")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Valor de cuota")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("T. Pagado")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Saldo")]),
                  _vm._v(" "),
                  _vm.form.id && !_vm.esFechaFutura && _vm.form.estado == "A"
                    ? _c("th", [_vm._v("Acciones")])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.form.prestamosFilter, function(prestamo, index) {
                  return _c(
                    "tr",
                    {
                      key: prestamo.prestamo_id + "-" + index,
                      class: _vm.getColorP(prestamo)
                    },
                    [
                      _c("th", [_vm._v(_vm._s(index + 1))]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-info btn--text",
                            attrs: { title: "Amortizaciones", type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.abrirModalAmortizaciones(index)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-table" })]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                " +
                            _vm._s(prestamo.cliente.descripcion) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                " +
                            _vm._s(prestamo.cliente.numero_identificacion) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                " +
                            _vm._s(prestamo.numero_documento) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                " +
                            _vm._s(prestamo.cuotas_canceladas) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                " +
                            _vm._s(prestamo.cuotas_faltantes) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                " +
                            _vm._s(prestamo.pagos_dominicales) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                " +
                            _vm._s(prestamo.atrasos) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                " +
                            _vm._s(prestamo.estado_descripcion) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.moneyFormat(prestamo.valor_cuota, 2)) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.moneyFormat(prestamo.total_pagado_dia, 2)
                            ) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.moneyFormat(prestamo.saldo, 2)) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.form.id &&
                      !_vm.esFechaFutura &&
                      _vm.form.estado == "A" &&
                      prestamo.cliente_ruta_cobro_id
                        ? _c("td", [
                            !prestamo.atraso && _vm.puedeAbonar
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn-success btn--text",
                                    attrs: { title: "Abonar", type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.abrirModalAbonos(index)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-money" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !prestamo.atraso && _vm.puedePagarDominical
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn-secondary btn--text",
                                    attrs: {
                                      title: prestamo.observacion_dominical
                                        ? "Ver observación"
                                        : "Dominical",
                                      type: "button"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.abrirModalDominical(index)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      class: [
                                        "fa",
                                        prestamo.observacion_dominical
                                          ? "fa-eye"
                                          : "fa-handshake-o"
                                      ]
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            prestamo.atraso && _vm.puedeNoPagar
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn-success btn--text",
                                    attrs: {
                                      title: "Cancelar no pago",
                                      type: "button"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.revertirAtraso(index)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-arrow-left" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !prestamo.atraso &&
                            _vm.puedeNoPagar &&
                            !prestamo.observacion_dominical
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn-danger btn--text",
                                    attrs: { title: "No pago", type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.abrirModalAtraso(index)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-ban" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !prestamo.atraso &&
                            prestamo.saldo > 0 &&
                            _vm.puedeRenovar &&
                            !prestamo.observacion_dominical
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn-primary btn--text",
                                    attrs: {
                                      title: "Renovación",
                                      type: "button"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.abrirModalPrestamo(
                                          index,
                                          "RN"
                                        )
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-repeat" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !prestamo.atraso &&
                            prestamo.saldo > 0 &&
                            _vm.puedeRefinanciar &&
                            !prestamo.observacion_dominical
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn-warning btn--text",
                                    attrs: {
                                      title: "Refinanciación",
                                      type: "button"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.abrirModalPrestamo(
                                          index,
                                          "RF"
                                        )
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-refresh" })]
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("tfoot", [
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.prestamosFilter.length === 0,
                        expression: "form.prestamosFilter.length === 0"
                      }
                    ]
                  },
                  [_vm._m(7)]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", [
              _vm._m(8),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("td", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.moneyFormat(_vm.cuotaPromedio, 2)) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.porcCobrado) +
                        " %\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.moneyFormat(_vm.form.deberia, 2)) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.moneyFormat(_vm.totalPagos, 2)) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.totalNoPagos) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.totalDominicales) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.totalRecibos) +
                        "\n              "
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-3" }, [
        _c("div", { staticClass: "col-md-3 mt-3" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "table-responsive" }, [
                _c("table", [
                  _c("tbody", [
                    _c("tr", [
                      _vm._m(9),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.moneyFormat(_vm.form.total_credito, 2)) +
                            "\n                  "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(10),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c("input-field", {
                              attrs: {
                                stretch: "",
                                vMoney: "",
                                format: _vm.money,
                                id: "total_efectivo",
                                placeholder: "##.##",
                                disabled: _vm.form.estado != "A"
                              },
                              model: {
                                value: _vm.form.total_efectivo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "total_efectivo", $$v)
                                },
                                expression: "form.total_efectivo"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(11),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c("input-field", {
                              attrs: {
                                stretch: "",
                                vMoney: "",
                                format: _vm.moneyNegative,
                                id: "vale_base",
                                placeholder: "##.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.vale_base,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "vale_base", $$v)
                                },
                                expression: "form.vale_base"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(12),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c("input-field", {
                              attrs: {
                                stretch: "",
                                vMoney: "",
                                format: _vm.money,
                                id: "total_deposito",
                                placeholder: "##.##",
                                disabled: _vm.form.estado != "A"
                              },
                              model: {
                                value: _vm.form.total_deposito,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "total_deposito", $$v)
                                },
                                expression: "form.total_deposito"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _c("b", [
                          _vm._v(
                            "Total microseguro (" +
                              _vm._s(
                                _vm.parametros
                                  ? _vm.parametros.porc_microseguro
                                  : 2
                              ) +
                              "%)"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("input-field", {
                            attrs: {
                              vMoney: "",
                              format: _vm.money,
                              id: "total_microseguro",
                              placeholder: "##.##",
                              disabled: _vm.form.estado != "A"
                            },
                            model: {
                              value: _vm.form.total_microseguro,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "total_microseguro", $$v)
                              },
                              expression: "form.total_microseguro"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(13),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.moneyFormat(_vm.subtotal, 2)))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(14),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.moneyFormat(
                              _vm.subtotal +
                                _vm.form.prestamo_efectivo +
                                _vm.form.prestamo_deposito +
                                _vm.form.prestamo_transferencia,
                              2
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(15),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("input-field", {
                            attrs: {
                              stretch: "",
                              vMoney: "",
                              format: _vm.money,
                              id: "total_entregado",
                              placeholder: "##.##",
                              disabled: _vm.form.estado != "A"
                            },
                            model: {
                              value: _vm.form.total_entregado,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "total_entregado", $$v)
                              },
                              expression: "form.total_entregado"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "d-flex ai-center jc-between" },
                          [
                            _c("b", [_vm._v("Gasto")]),
                            _vm._v(" "),
                            _vm.form.gasto > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn-secondary btn--text",
                                    attrs: {
                                      type: "button",
                                      title: "Observación"
                                    },
                                    on: { click: _vm.openModalGasto }
                                  },
                                  [_c("i", { staticClass: "fa fa-eye" })]
                                )
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c("input-field", {
                              attrs: {
                                stretch: "",
                                vMoney: "",
                                format: _vm.money,
                                id: "gasto",
                                placeholder: "##.##",
                                disabled: _vm.form.estado != "A"
                              },
                              model: {
                                value: _vm.form.gasto,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "gasto", $$v)
                                },
                                expression: "form.gasto"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "d-flex ai-center jc-between" },
                          [
                            _c("b", [_vm._v("Vale")]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-secondary btn--text",
                                attrs: {
                                  type: "button",
                                  title: "Observación de vale"
                                },
                                on: { click: _vm.openModalObsVale }
                              },
                              [_c("i", { staticClass: "fa fa-eye" })]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.vale))])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.form.id && !_vm.esFechaFutura
          ? _c("div", { staticClass: "col-md-3 mt-3" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(16),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", [
                      _c("tbody", [
                        _c("tr", [
                          _vm._m(17),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.moneyFormat(_vm.form.prestamo_efectivo, 2)
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _vm._m(18),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.moneyFormat(_vm.form.prestamo_deposito, 2)
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _vm._m(19),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.moneyFormat(
                                  _vm.form.prestamo_transferencia,
                                  2
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _vm._m(20),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.moneyFormat(
                                    _vm.form.prestamo_efectivo +
                                      _vm.form.prestamo_deposito +
                                      _vm.form.prestamo_transferencia,
                                    2
                                  )
                                ) +
                                "\n                  "
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.form.prestamosRN.length > 0
          ? _c("div", { staticClass: "col-md-6 mt-3" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card__title" }, [
                  _c("h5", [
                    _vm._v(
                      "Renovaciones (" +
                        _vm._s(_vm.form.prestamosRN.length) +
                        ")"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", [
                      _vm._m(21),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.form.prestamosRN, function(
                          prestamoRN,
                          indexRN
                        ) {
                          return _c(
                            "tr",
                            { key: prestamoRN.prestamo_id + "-" + indexRN },
                            [
                              _c("th", [_vm._v(_vm._s(indexRN + 1))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(prestamoRN.cliente.descripcion) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      prestamoRN.cliente.numero_identificacion
                                    ) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(prestamoRN.numero_documento) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      prestamoRN.prestamo_ref.numero_documento
                                    ) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.moneyFormat(prestamoRN.valor_cuota, 2)
                                    ) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.moneyFormat(
                                        parseFloat(prestamoRN.total_pagado) +
                                          parseFloat(prestamoRN.saldo),
                                        2
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.form.prestamosRF.length > 0
          ? _c("div", { staticClass: "col-md-6 mt-3" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card__title" }, [
                  _c("h5", [
                    _vm._v(
                      "Refinanciamientos (" +
                        _vm._s(_vm.form.prestamosRF.length) +
                        ")"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", [
                      _vm._m(22),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.form.prestamosRF, function(
                          prestamoRF,
                          indexRF
                        ) {
                          return _c(
                            "tr",
                            { key: prestamoRF.prestamo_id + "-" + indexRF },
                            [
                              _c("th", [_vm._v(_vm._s(indexRF + 1))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(prestamoRF.cliente.descripcion) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      prestamoRF.cliente.numero_identificacion
                                    ) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(prestamoRF.numero_documento) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      prestamoRF.prestamo_ref.numero_documento
                                    ) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.moneyFormat(prestamoRF.valor_cuota, 2)
                                    ) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.moneyFormat(
                                        parseFloat(prestamoRF.total_pagado) +
                                          parseFloat(prestamoRF.saldo),
                                        2
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.form.prestamosNR.length > 0
          ? _c("div", { staticClass: "col-md-6 mt-3" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card__title" }, [
                  _c("h5", [
                    _vm._v(
                      "Nuevos (" + _vm._s(_vm.form.prestamosNR.length) + ")"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", [
                      _vm._m(23),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.form.prestamosNR, function(
                          prestamoNR,
                          indexNR
                        ) {
                          return _c(
                            "tr",
                            { key: prestamoNR.prestamo_id + "-" + indexNR },
                            [
                              _c("th", [_vm._v(_vm._s(indexNR + 1))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(prestamoNR.cliente.descripcion) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      prestamoNR.cliente.numero_identificacion
                                    ) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(prestamoNR.numero_documento) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.moneyFormat(prestamoNR.valor_cuota, 2)
                                    ) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.moneyFormat(
                                        parseFloat(prestamoNR.total_pagado) +
                                          parseFloat(prestamoNR.saldo),
                                        2
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "modalAbonos",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "50%",
            clickToClose: ""
          }
        },
        [
          _c("modal-abono", {
            attrs: { "fecha-ruta-cobro": _vm.form.fecha },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("modalAbonos")
              },
              input: _vm.inputModalAbono
            },
            model: {
              value: _vm.selectedPrestamo,
              callback: function($$v) {
                _vm.selectedPrestamo = $$v
              },
              expression: "selectedPrestamo"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "prestamo",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "65%",
            clickToClose: false
          }
        },
        [
          _c("prestamo", {
            attrs: {
              porcInteres: _vm.parametros ? _vm.parametros.porc_interes : null,
              cuotas: _vm.parametros ? _vm.parametros.cuotas : null,
              puedeCambiarInteres: "",
              prestamoRefId: _vm.selectedPrestamo
                ? _vm.selectedPrestamo.prestamo_id
                : "",
              tipoPrestamo: _vm.tipoPrestamo,
              ruta: _vm.selectedRuta,
              "valor-pago-rf": _vm.selectedPrestamo
                ? _vm.selectedPrestamo.pago.valor
                : 0,
              "fecha-ruta-cobro": _vm.form.fecha ? _vm.form.fecha : ""
            },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("prestamo")
              },
              guardar: _vm.guardarPrestamo
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "dominical",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "50%",
            clickToClose: ""
          }
        },
        [
          _c("observacion-dominical", {
            attrs: { errores: _vm.errores },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("dominical")
              },
              input: _vm.inputDominical
            },
            model: {
              value: _vm.selectedPrestamo,
              callback: function($$v) {
                _vm.selectedPrestamo = $$v
              },
              expression: "selectedPrestamo"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "modalAtraso",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "50%",
            clickToClose: ""
          }
        },
        [
          _c("modal-atraso", {
            attrs: {
              porcentajeMulta: _vm.parametros.porc_multa,
              errores: _vm.errores
            },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("modalAtraso")
              },
              input: _vm.registrarAtraso
            },
            model: {
              value: _vm.selectedPrestamo,
              callback: function($$v) {
                _vm.selectedPrestamo = $$v
              },
              expression: "selectedPrestamo"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "auditorias",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "70%",
            clickToClose: ""
          }
        },
        [
          _c("auditoria", {
            attrs: { modulo: "RC", identificacion: _vm.form.numero_documento }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "amortizaciones",
            scrollable: "",
            reset: "",
            adaptative: "",
            resizable: "",
            height: "auto",
            width: "50%",
            clickToClose: ""
          }
        },
        [
          _c("amortizaciones", {
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("amortizaciones")
              }
            },
            model: {
              value: _vm.selectedPrestamo,
              callback: function($$v) {
                _vm.selectedPrestamo = $$v
              },
              expression: "selectedPrestamo"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "gasto",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "50%",
            clickToClose: ""
          }
        },
        [
          _c("div", { staticClass: "layout" }, [
            _c("div", { staticClass: "layout__header" }, [
              _c("div", { staticClass: "layout__title" }, [
                _c("h3", [
                  _vm._v("\n            Observación Gasto\n          ")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c(
                    "textarea-field",
                    {
                      attrs: {
                        placeholder: "Escriba una observación",
                        id: "observacion_gasto",
                        name: "observacion_gasto"
                      },
                      model: {
                        value: _vm.form.observacion_gasto,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "observacion_gasto", $$v)
                        },
                        expression: "form.observacion_gasto"
                      }
                    },
                    [_c("span", [_vm._v("Observaciones")])]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "btn-danger btn--text",
                  on: {
                    click: function($event) {
                      return _vm.$modal.hide("gasto")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-times" }),
                  _c("span", [_vm._v("Cerrar")])
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "clientes-agendados",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "70%",
            clickToClose: false
          }
        },
        [
          _c("creditos-agendados", {
            attrs: { "ruta-cobro-id": _vm.form.id },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("clientes-agendados")
              },
              guardar: _vm.agregarCreditosAgendados
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "fechaMasiva",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "30%",
            clickToClose: ""
          }
        },
        [
          _c("div", { staticClass: "layout" }, [
            _c("div", { staticClass: "layout__header" }, [
              _c("div", { staticClass: "layout__title" }, [
                _c("h3", [
                  _vm._v(
                    "\n            Actualizar masivamente fecha de próximo pago\n          "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    { staticClass: "datepicker-field" },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "fecha_masiva",
                          locale: "es",
                          "no-label": "",
                          "only-date": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione una fecha..."
                        },
                        model: {
                          value: _vm.obj.fecha_masiva,
                          callback: function($$v) {
                            _vm.$set(_vm.obj, "fecha_masiva", $$v)
                          },
                          expression: "obj.fecha_masiva"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Fecha")])
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "btn-success",
                  on: { click: _vm.asignarFechaMasiva }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _c("span", [_vm._v("Guardar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-danger btn--text",
                  on: {
                    click: function($event) {
                      return _vm.$modal.hide("fechaMasiva")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-times" }),
                  _c("span", [_vm._v("Cerrar")])
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "obs-vale",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "50%",
            clickToClose: ""
          }
        },
        [
          _c("div", { staticClass: "layout" }, [
            _c("div", { staticClass: "layout__header" }, [
              _c("div", { staticClass: "layout__title" }, [
                _c("h3", [_vm._v("\n            Observación Vale\n          ")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c(
                    "textarea-field",
                    {
                      attrs: {
                        placeholder: "Escriba una observación",
                        id: "observacion_vale",
                        name: "observacion_vale"
                      },
                      model: {
                        value: _vm.form.observacion_vale,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "observacion_vale", $$v)
                        },
                        expression: "form.observacion_vale"
                      }
                    },
                    [_c("span", [_vm._v("Observaciones")])]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "btn-danger btn--text",
                  on: {
                    click: function($event) {
                      return _vm.$modal.hide("obs-vale")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-times" }),
                  _c("span", [_vm._v("Cerrar")])
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "dominical-ruta",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "50%",
            clickToClose: ""
          }
        },
        [
          _c("div", { staticClass: "layout" }, [
            _c("div", { staticClass: "layout__header" }, [
              _c("div", { staticClass: "layout__title" }, [
                _c("h3", [
                  _vm._v("\n            Pago dominical a la ruta\n          ")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c(
                    "textarea-field",
                    {
                      attrs: {
                        placeholder: "Escriba una observación",
                        id: "observaciones"
                      },
                      model: {
                        value: _vm.observacion_dominical,
                        callback: function($$v) {
                          _vm.observacion_dominical = $$v
                        },
                        expression: "observacion_dominical"
                      }
                    },
                    [_c("span", [_vm._v("Observaciones")])]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "btn-success",
                  on: { click: _vm.pagarDominicalRuta }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _c("span", [_vm._v("Guardar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-danger btn--text",
                  on: {
                    click: function($event) {
                      return _vm.$modal.hide("dominical-ruta")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-times" }),
                  _c("span", [_vm._v("Cancelar")])
                ]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información de ruta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "indicadores__item" }, [
      _c("div", { staticClass: "indicadores__item__color" }, [
        _c("div", { staticClass: "bg-atraso" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "indicadores__item__title" }, [
        _c("span", [_vm._v("Atraso")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "indicadores__item" }, [
      _c("div", { staticClass: "indicadores__item__color" }, [
        _c("div", { staticClass: "bg-dominical" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "indicadores__item__title" }, [
        _c("span", [_vm._v("Dominical")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "indicadores__item" }, [
      _c("div", { staticClass: "indicadores__item__color" }, [
        _c("div", { staticClass: "bg-renovacion" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "indicadores__item__title" }, [
        _c("span", [_vm._v("Renovación")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "indicadores__item" }, [
      _c("div", { staticClass: "indicadores__item__color" }, [
        _c("div", { staticClass: "bg-refinanciacion" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "indicadores__item__title" }, [
        _c("span", [_vm._v("Refinanciación")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "indicadores__item" }, [
      _c("div", { staticClass: "indicadores__item__color" }, [
        _c("div", { staticClass: "bg-abonos" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "indicadores__item__title" }, [
        _c("span", [_vm._v("Abonos")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "indicadores__item" }, [
      _c("div", { staticClass: "indicadores__item__color" }, [
        _c("div", { staticClass: "bg-deposito" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "indicadores__item__title" }, [
        _c("span", [_vm._v("Depósitos")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "12" } }, [
      _c("strong", [_vm._v(" No se ha encontrado préstamos. ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Cuota promedio")]),
        _vm._v(" "),
        _c("th", [_vm._v("% Cobrado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Debería")]),
        _vm._v(" "),
        _c("th", [_vm._v("T. Pagos")]),
        _vm._v(" "),
        _c("th", [_vm._v("T. No Pagos")]),
        _vm._v(" "),
        _c("th", [_vm._v("T. Dominicales")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total recibos")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Total crédito")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Base")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Vale")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Total depósito")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Subtotal")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Total a recibir")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Total entregado")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Cuotas pagadas")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Total efectivo")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Total depósito")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Total transferencia")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Total recaudado")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Cliente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cédula")]),
        _vm._v(" "),
        _c("th", [_vm._v("Crédito")]),
        _vm._v(" "),
        _c("th", [_vm._v("Préstamo referencia")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor de cuota")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Cliente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cédula")]),
        _vm._v(" "),
        _c("th", [_vm._v("Crédito")]),
        _vm._v(" "),
        _c("th", [_vm._v("Préstamo referencia")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor de cuota")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Cliente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cédula")]),
        _vm._v(" "),
        _c("th", [_vm._v("Crédito")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor de cuota")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-003166bd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-003166bd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/cobros/RutaCobros.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-003166bd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/cobros/RutaCobros.vue
// module chunks = 0